exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Main{position:relative;width:100%;background-color:black}.Main__sections{position:relative;top:80px}.Main .arrowUpDiv{right:-250px}.Main__scroll-up.active .arrowUpDiv{right:-5px}\n", ""]);
